export default "__VITE_ASSET__f4182d70__"